<template>
  <div>
    <v-toolbar flat color="white"
      ><v-spacer></v-spacer
      ><v-text-field label="Search" v-model="search"></v-text-field
      ><v-btn round color="primary" @click="addItem()"
        >Add Category</v-btn
      ></v-toolbar
    >
    <v-data-table :items="categories" :headers="headers" hide-actions>
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon v-if="props.item.isEditable" @click="editItem(props.item)"
            >edit</v-icon
          >
          <v-icon v-if="props.item.isEditable" @click="deleteItem(props.item)"
            >delete</v-icon
          >
        </td>
        <td class="text-xs-center">
          {{ props.item.name }}
        </td>
        <td class="text-xs-center">
          {{ props.item.code }}
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="addModal" persisitent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Add Ticket Category</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="item.name"
            flat
            class="white--text"
            @click="createCategory()"
            >Save</v-btn
          >
          <v-btn flat v-else disabled>Save</v-btn>

          <v-btn
            flat
            color="white"
            class="white--text"
            @click="(item = {}), (addModal = false)"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text mx-3>
          <v-layout mx-3>
            <v-flex xs4>
              <v-text-field
                class="mx-1"
                label="Name"
                v-model="item.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                class="mx-1"
                label="Code"
                v-model="item.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-select
                class="mx-1"
                v-model="item.organisationTypeId"
                :items="organisationtypes"
                item-text="name"
                item-value="id"
                label="Organisation Type"
              ></v-select>
            </v-flex>
          </v-layout>
          <h3 class="grey--text">Category Items:</h3>

          <v-layout align-center mx-3>
            <v-flex xs4 class="mx-1">
              <v-text-field label="Name" v-model="name"></v-text-field>
            </v-flex>
            <v-flex xs4 class="mx-1">
              <v-text-field label="Code" v-model="code"></v-text-field>
            </v-flex><v-flex xs1>
              <v-icon
                v-if=" name && code"
                @click="
                  item.ticketCategoryItems.push({
                     name: name,
                      code: code,
                      editable:false,
                      formRequired:false,
                      formId:null
                  }),
                    (name = ''),
                    (code = '')
                "
                color="primary"
                >add_circle</v-icon
              >
              <v-icon disabled v-else>add_circle</v-icon>
            </v-flex>
          </v-layout>
          <v-container v-if="item.ticketCategoryItems&&item.ticketCategoryItems.length>0">
                <v-flex
                xs12>
                  <v-layout  mx-2>
                  <v-flex xs4  mx-2
                    ><h3 class="grey--text">Name</h3></v-flex
                  >
                  <v-flex xs4 mx-2
                    ><h3 class="grey--text">Code</h3></v-flex
                  >
                  <v-flex xs4 mx-2
                    >
                    <h3 class="grey--text">Form</h3></v-flex
                  >
                  <v-flex xs4 mx-2
                    >
                    <h3 class="grey--text">Form Required</h3></v-flex
                  >

                  <v-flex xs2 mx-2
                    > <h3 class="grey--text">Action</h3></v-flex
                  >
                </v-layout>
                </v-flex>
              <v-flex
                xs12
                v-for="subItem in item.ticketCategoryItems"
                :key="subItem.name"
              >
                <v-layout class="justify-center" :key="keyEdit" v-if="!subItem.editable" mx-2>
                  <v-flex xs4 mx-1
                    ><span class="grey--text">{{ subItem.name }}</span></v-flex
                  >
                  <v-flex xs4 mx-1
                    ><span class="grey--text">{{ subItem.code }}</span></v-flex
                  >
                  <v-flex xs4 mx-1
                    ><span v-if="subItem.formId" class="grey--text">{{ subItem.formName }}</span>
                    <span v-else class="grey--text"></span></v-flex
                  >
                  <v-flex xs4 mx-1>
                      <v-icon v-if="subItem.formRequired" color="green">done</v-icon>
                    
                      <v-icon v-else color="red">not_interested</v-icon>
                   </v-flex
                  >

                  <v-flex xs2 mx-1
                    ><v-icon @click="editTicketCategoryItem(subItem)"
                      >edit</v-icon
                    
                    ><v-icon @click="removeTicketCategoryItem(subItem)"
                      >delete</v-icon
                    ></v-flex
                  >
                </v-layout>
                <v-layout class="justify-center" :key="keyEdit" v-else mx-2>
                  <v-flex xs4 mx-1>
                    <v-text-field class="justify-center input-flex-min-space"
                      v-model="subItem.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 mx-1
                    ><v-text-field class="justify-center input-flex-min-space"
                      v-model="subItem.code"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs4 mx-1>
                    <v-autocomplete
                    class="justify-center input-flex-min-space"
                      clearable
                       item-text="name"
                    item-value="id"
                      flat
                      color="primary"
                      :items="forms"
                      v-model="subItem.formId"
                    ></v-autocomplete
                  ></v-flex>
                  <v-flex xs4 mx-1>
                    <v-layout justify-center>
                    <v-checkbox class="justify-center align-center input-flex-min-space"
                      v-model="subItem.formRequired"
                    ></v-checkbox>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 mx-1
                    ><v-btn class="justify-center align-center input-flex-min-space" round color="primary" small @click="editTicketCategoryItem(subItem)"
                      >Done</v-btn
                    ></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Edit Ticket Category</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="item.name && item.organisationTypeId"
            flat
            class="white--text"
            @click="updateCategory()"
            >Save</v-btn
          >
          <v-btn flat v-else disabled>Save</v-btn>

          <v-btn
            flat
            color="white"
            class="white--text"
            @click="(item = {}), (editModal = false)"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text mx-3>
          <v-layout mx-3>
            <v-flex xs4 mx-2>
              <v-text-field label="Name" v-model="item.name"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-2>
              <v-text-field label="Code" v-model="item.code"></v-text-field>
            </v-flex>
             <v-flex xs4 mx-2>
              <v-select
                v-model="item.organisationTypeId"
                :items="organisationtypes"
                item-text="name"
                item-value="id"
                label="Organisation Type"
              ></v-select>
            </v-flex>
          </v-layout>

          <div>
            <h3 class="grey--text">Category Items:</h3>
            <v-layout mx-3>
              <v-flex xs4 mx-2>
                <v-text-field label="Name" v-model="name"></v-text-field>
              </v-flex>
              <v-flex xs4 mx-2>
                <v-text-field label="Code" v-model="code"></v-text-field>
              </v-flex><v-flex xs1>
                <v-icon
                  v-if="name && code "
                  @click="
                    item.ticketCategoryItems.push({
                      name: name,
                      code: code,
                      editable:false,
                      formRequired:false,
                      formId:null
                    }),
                      (name = ''),
                      (code = '')
                  "
                  color="primary"
                  >add_circle</v-icon
                >
                <v-icon disabled v-else>add_circle</v-icon>
              </v-flex>
            </v-layout>
            <v-container>
                <v-flex
                xs12>
                  <v-layout  mx-2>
                  <v-flex xs4  mx-2
                    ><h3 class="grey--text">Name</h3></v-flex
                  >
                  <v-flex xs4 mx-2
                    ><h3 class="grey--text">Code</h3></v-flex
                  >
                  <!-- <v-flex xs4 mx-2
                    ><h3 class="grey--text">Colour</h3></v-flex
                  > -->
                  <v-flex xs4 mx-2
                    >
                    <h3 class="grey--text">Form</h3></v-flex
                  >
                  <v-flex xs4 mx-2
                    >
                    <h3 class="grey--text">Form Required</h3></v-flex
                  >

                  <v-flex xs2 mx-2
                    > <h3 class="grey--text">Action</h3></v-flex
                  >
                </v-layout>
                </v-flex>
              <v-flex
                xs12
                v-for="subItem in item.ticketCategoryItems"
                :key="subItem.name"
              >
                <v-layout class="justify-center" :key="keyEdit" v-if="!subItem.editable" mx-2>
                  <v-flex xs4 mx-1
                    ><span class="grey--text">{{ subItem.name }}</span></v-flex
                  >
                  <v-flex xs4 mx-1
                    ><span class="grey--text">{{ subItem.code }}</span></v-flex
                  >
                  <!-- <v-flex xs4 mx-1
                    ><span class="grey--text">{{ subItem.colour }}</span></v-flex
                  > -->
                  <v-flex xs4 mx-1
                    ><span v-if="subItem.formId" class="grey--text">{{ subItem.formName }}</span>
                    <span v-else class="grey--text"></span></v-flex
                  >
                  <v-flex xs4 mx-1>
                      <v-icon v-if="subItem.formRequired" color="green">done</v-icon>
                    
                      <v-icon v-else color="red">not_interested</v-icon>
                   </v-flex
                  >

                  <v-flex xs2 mx-1
                    ><v-icon @click="editTicketCategoryItem(subItem)"
                      >edit</v-icon
                    
                    ><v-icon @click="removeTicketCategoryItem(subItem)"
                      >delete</v-icon
                    ></v-flex
                  >
                </v-layout>
                <v-layout class="justify-center" :key="keyEdit" v-else mx-2>
                  <v-flex xs4 mx-1>
                    <v-text-field class="justify-center input-flex-min-space"
                      v-model="subItem.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 mx-1
                    ><v-text-field class="justify-center input-flex-min-space"
                      v-model="subItem.code"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs4 mx-1>
                    <v-autocomplete
                    class="justify-center input-flex-min-space"
                      clearable
                       item-text="name"
                    item-value="id"
                      flat
                      color="primary"
                      :items="forms"
                      v-model="subItem.formId"
                    ></v-autocomplete
                  ></v-flex>
                  <v-flex xs4 mx-1>
                    <v-layout justify-center>
                    <v-checkbox class="justify-center align-center input-flex-min-space"
                      v-model="subItem.formRequired"
                    ></v-checkbox>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 mx-1
                    ><v-btn class="justify-center align-center input-flex-min-space" round color="primary" small @click="editTicketCategoryItem(subItem)"
                      >Done</v-btn
                    ></v-flex
                  >
                </v-layout>
              </v-flex>
            </v-container>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api.js";
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import { Chrome } from "vue-color";
export default {
  components: {
    chromepicker: Chrome,
    'v-swatches': VSwatches
  },
  props: ["categories", "organisationtypes"],
  data() {
    return {
      forms:[],
      keyEdit:0,
      item: {},
      chooseColourBtn: true,
      colour: "#000000",
      search: "",
      addModal: false,
      editModal: false,
      name: "",
      code: "",
      hexColour: "",
      iconOptions: [
        "account_circle",
        "build",
        "assessment",
        "grade",
        "devices",
        "merge_type",
        "device_hub",
        "toys",
        "home_work",
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Code",
          align: "center",
          value: "code",
        },
      ],
    };
  },
  created(){
this.fetchForms()
  },
  methods: {
      fetchForms(){
          Api().get('/forms/basic').then(response=>{
              this.forms = response.data
          })
      },
    fetchTicketCategoryItems(id) {
      Api()
        .get("/ticketCategoryItem/byCategory/" + id)
        .then((response) => {
          this.item.ticketCategoryItems = response.data;
          this.item.ticketCategoryItems.map((x) => {
            x.editable = false
            if(x.formId){
            x.formName = x.form.name
            }
          });
          this.editModal = true;
        });
    },
    changeBtn() {
      if (this.chooseColourBtn === false) {
        this.chooseColourBtn = true;
      } else {
        this.chooseColourBtn = false;
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.item = {
          ticketCategoryItems: [],
        };
        this.addModal = true;
      }
    },
    createCategory() {
      Api()
        .post("/ticketCategory", this.item)
        .then(async (response) => {
          let subItems = [];
          await this.item.ticketCategoryItems.map((x) => {
            subItems.push({
              ticketCategoryId: response.data.id,
              name: x.name,
              code: x.code,
              formId: x.formId,
              formRequired: x.formRequired,
            });
          });
          Api()
            .post("/ticketCategoryItem", {
              batch: subItems,
            })
            .then((response) => {});
          this.categories.push(response.data);
          this.addModal = false;
          this.item = {};
        });
    },
    updateCategory() {
      Api()
        .put("/ticketCategory/" + this.item.id, this.item)
        .then(async (response) => {
          let index = this.categories.indexOf(
            this.categories.find((x) => x.id === this.item.id)
          );
          this.categories[index] = this.item;
          this.editModal = false;

          let subItems = [];
          await this.item.ticketCategoryItems.map((x) => {  
          if(typeof x.id === 'undefined'){
            Api()
            .post("/ticketCategoryItem", {
                ticketCategoryId: this.item.id,
                name: x.name,
                code: x.code,
                formId: x.formId,
                formRequired: x.formRequired,
            })  
         }else{

                                      
               Api()
            .put("/ticketCategoryItem/"+x.id, {
                ticketCategoryId: this.item.id,
                name: x.name,
                code: x.code,
                formId: x.formId,
                formRequired: x.formRequired,
            })  
    }
          });
         
          this.item = {};
        });
    },
    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.name = "";
        this.code = "";
        this.fetchTicketCategoryItems(item.id);
        this.item = item;
      }
    },
    deleteItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/ticketCategory/" + item.id, {
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              let index = this.categories.indexOf(item);
              this.categories.splice(index, 1);
            });
      }
    },
    editTicketCategoryItem(item) {
        console.log(item)
      let index = this.item.ticketCategoryItems.indexOf(item);
      if(this.item.ticketCategoryItems[index].editable ==false){
      this.item.ticketCategoryItems[index].editable = true;
      }else{
      this.item.ticketCategoryItems[index].name = item.name
      this.item.ticketCategoryItems[index].code = item.code
      if(item.formId=='undefined'||item.formId==null){
      this.item.ticketCategoryItems[index].formId = null
      }else{
      this.item.ticketCategoryItems[index].formId = item.formId
      }
      if(item.formId){
      this.item.ticketCategoryItems[index].formName = this.forms.find(x => x.id === item.formId).name

      }
      if(this.item.ticketCategoryItems[index].formId==null){
       this.item.ticketCategoryItems[index].formRequired=false   
      }else{
      this.item.ticketCategoryItems[index].formRequired = item.formRequired
      }
      this.item.ticketCategoryItems[index].editable = false;
      }
      console.log(this.item.ticketCategoryItems[index])
      this.keyEdit++
    },
    removeTicketCategoryItem(item) {
      let index = this.item.ticketCategoryItems.indexOf(item);
      this.item.ticketCategoryItems.splice(index, 1);
      Api().put("/ticketCategoryItem/" + item.id, {
        isActive: false,
        isDeleted: true,
      });
    },
  },
};
</script>